export type CalendarView = 'month' | 'week';

export const FullCalendarViewNames: { [view in CalendarView]: string } = {
    month: 'dayGridMonth',
    week: 'timeGridWeek'
};
